import { useRouteError } from 'react-router';

export default function ErrorPage() {
  const error = useRouteError() as { statusText: string; message: string };

  console.error(error);

  return (
    <div id='error-page' style={{ textAlign: 'center' }}>
      <h1>Oops!</h1>
      <p>Desculpe, aconteceu um erro inesperado.</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </div>
  );
}
